import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GuideTitleDesktop = styled(Typography)(() => ({
  fontSize: '40px',
  fontWeight: 500,
  color: 'black',
  textAlign: 'left',
}));
